<template>
	<div>
    <el-form ref="form" label-position="left" label-width="90px" style="width: 60%">
      <el-form-item label="报警邮箱" prop="name">
        <el-input></el-input>
      </el-form-item>
      <el-form-item>
        <el-button>重置</el-button>
        <el-button type="primary" @click="onCreate()">立即创建</el-button>
      </el-form-item>
    </el-form>
	</div>

</template>

<script>
  import axios from 'axios'
  import { baseurl } from '../../api/url'
	export default{
		data(){
			return {}
		},
		created(){
		},
		methods:{
			// 创建报警邮箱
      onCreate () {

      }
		}
	}
</script>



// WEBPACK FOOTER //
// menu-add.vue?32182f74